module.exports = __webpack_public_path__ + "img/gzhQrCode.174fb470.png";